namespace SorAraBul.PropertyManagement {
    export interface PropertiesRow {
        Id?: number;
        PropertyType?: PropertyTypes;
        PropertyName?: string;
        Address?: string;
        Images?: string;
        RequestedRentAmount?: number;
        RequestedRentAmountWithCurrency?: string;
        RequestedRentCurrencyId?: number;
        RequestedRentCurrencyLookupName?: string;
        Code?: string;
        CompanyId?: number;
        PropertyFullName?: string;
        PropertyLocation?: string;
        InsertDate?: string;
        InsertUserId?: number;
        UpdateDate?: string;
        UpdateUserId?: number;
        Restrictions?: number[];
        CityId?: number;
        CityName?: string;
        IlceId?: number;
        TownName?: string;
        QuarterId?: number;
        QuarterName?: string;
    }

    export namespace PropertiesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PropertyName';
        export const localTextPrefix = 'PropertyManagement.Properties';
        export const deletePermission = 'Properties:Delete';
        export const insertPermission = 'Properties:Insert';
        export const readPermission = 'Properties:View';
        export const updatePermission = 'Properties:Update';

        export declare const enum Fields {
            Id = "Id",
            PropertyType = "PropertyType",
            PropertyName = "PropertyName",
            Address = "Address",
            Images = "Images",
            RequestedRentAmount = "RequestedRentAmount",
            RequestedRentAmountWithCurrency = "RequestedRentAmountWithCurrency",
            RequestedRentCurrencyId = "RequestedRentCurrencyId",
            RequestedRentCurrencyLookupName = "RequestedRentCurrencyLookupName",
            Code = "Code",
            CompanyId = "CompanyId",
            PropertyFullName = "PropertyFullName",
            PropertyLocation = "PropertyLocation",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            UpdateDate = "UpdateDate",
            UpdateUserId = "UpdateUserId",
            Restrictions = "Restrictions",
            CityId = "CityId",
            CityName = "CityName",
            IlceId = "IlceId",
            TownName = "TownName",
            QuarterId = "QuarterId",
            QuarterName = "QuarterName"
        }
    }
}
